/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentConfigSpecLimitsInner } from './componentConfigSpecLimitsInner';
import { ComponentConfigSpecSettingsInner } from './componentConfigSpecSettingsInner';
import { DisconnectedComponentConfigSpecCommerce } from './disconnectedComponentConfigSpecCommerce';
import { ComponentConfigSpecCompliance } from './componentConfigSpecCompliance';
import { ComponentConfigSpecServiceConsole } from './componentConfigSpecServiceConsole';
import { ComponentConfigSpecFeatureFlagsInner } from './componentConfigSpecFeatureFlagsInner';


export interface DisconnectedComponentConfigSpec { 
    auth?: object;
    commerce?: DisconnectedComponentConfigSpecCommerce;
    compliance?: ComponentConfigSpecCompliance;
    /**
     * Component ID
     */
    component_id?: string;
    /**
     * Current Timestamp
     */
    current_ts?: Date;
    entities?: Array<string>;
    feature_flags?: Array<ComponentConfigSpecFeatureFlagsInner>;
    /**
     * Generation Count
     */
    generation_count?: number;
    limits?: Array<ComponentConfigSpecLimitsInner>;
    /**
     * Organization Id.
     */
    org_id?: string;
    service_console?: ComponentConfigSpecServiceConsole;
    settings?: Array<ComponentConfigSpecSettingsInner>;
}

